import { render, staticRenderFns } from "./fullActivitys.vue?vue&type=template&id=71f0e1be&scoped=true&"
import script from "./fullActivitys.vue?vue&type=script&lang=js&"
export * from "./fullActivitys.vue?vue&type=script&lang=js&"
import style0 from "./fullActivitys.vue?vue&type=style&index=0&id=71f0e1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f0e1be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f0e1be')) {
      api.createRecord('71f0e1be', component.options)
    } else {
      api.reload('71f0e1be', component.options)
    }
    module.hot.accept("./fullActivitys.vue?vue&type=template&id=71f0e1be&scoped=true&", function () {
      api.rerender('71f0e1be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fullActivitys.vue"
export default component.exports